import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function jotFormReducer(state = initialState.jotForm, action) {
  switch (action.type) {
    case types.SUBMIT_JOT_FORM_SUCCESS:
      return action.jotFormSubmitResult;
    default:
      return state;
  }
}
